<template>
  <div class="ts-flux-table-container mt-6">
    <v-data-table
      :headers="headers"
      :items="flux"
      :search="search"
      :options.sync="options"
      :server-items-length="totalFlux"
      :loading="loading"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 20, 50, 100],
      }"
    >
      <template v-slot:top>
        <v-row class="pa-5">
          <v-spacer />
          <v-col cols="6">
            <v-text-field
              v-model="options.search"
              append-icon="mdi-magnify"
              single-line
              solo
              dense
              flat
              hide-details
              class="elevation-1 grey--text"
            >
              <template v-slot:label>
                <small>Rechercher par nom</small>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.active`]="{ item }">
        <v-chip :color="item.active ? 'secondary' : 'grey'" small label dark>
          <v-icon small left>
            {{
              item.active
                ? 'mdi-play-circle-outline'
                : 'mdi-pause-circle-outline'
            }}
          </v-icon>
          {{ item.active ? 'Activé' : 'Désactivé' }}
        </v-chip>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>
      <template v-slot:[`item.updatedAt`]="{ item }">
        {{ formatDate(item.updatedAt) }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
              @click="editFlux(item)"
              color="primary"
              dark
              icon
              v-on="tooltip"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Modifier le flux</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
              :to="{ name: 'FluxEdit', params: { id: item.id } }"
              color="primary"
              dark
              icon
              v-on="tooltip"
            >
              <v-icon small>mdi-cog</v-icon>
            </v-btn>
          </template>
          <span>Configurer le flux</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn @click="deleteFlux(item)" icon v-on="tooltip">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Supprimer le flux</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { cloneDeep } from 'lodash-es'
export default {
  name: 'TSFluxTable',
  props: {
    flux: {
      type: Array,
      default: () => [],
    },
    totalFlux: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'start',
          sortable: true,
          value: 'id',
        },
        { text: 'Nom', value: 'name' },
        { text: 'État', value: 'active' },
        { text: 'Description', value: 'description' },
        { text: 'Modifié le', value: 'updatedAt' },
        { text: 'Actions', align: 'center', value: 'actions', sortable: false },
      ],
      options: {
        search: '',
        itemsPerPage: 10,
      },
      search: '',
    }
  },
  watch: {
    options: {
      handler() {
        this.$emit('optionsChange', this.options)
      },
      deep: true,
    },
  },
  methods: {
    deleteFlux(user) {
      this.$emit('delete', user.id)
    },
    editFlux(user) {
      this.$emit('edit', cloneDeep(user))
    },
    formatDate(date) {
      return format(parseISO(date), 'dd/MM/yyyy')
    },
  },
}
</script>

<style lang="scss" scoped>
.ts-flux-table-container {
  width: 100%;
}
</style>
